import type {PropsWithChildren} from 'react';

import {Anchor} from '../multi_combo_box/anchor.js';
import {MultiComboBox} from '../multi_combo_box/index.js';
import type {
  MultiComboBoxItemsProps,
  MultiComboBoxLoadItemsProps,
} from '../multi_combo_box/index.js';
import {Items} from '../multi_combo_box/items.js';
import {Search} from '../multi_combo_box/search.js';
import {SelectedItems} from '../multi_combo_box/selected_items.js';
import {Surface} from '../multi_combo_box/surface.js';
import {ToggleButton} from '../multi_combo_box/toggle_button.js';

type ComboBoxProps<T> = PropsWithChildren<
  | Omit<MultiComboBoxItemsProps<T>, 'as'>
  | Omit<MultiComboBoxLoadItemsProps<T>, 'as'>
>;

const Root = <T,>(props: ComboBoxProps<T>) => {
  if (props.loadItems) {
    const {items: _items, isLoading: _isLoading, ...rest} = props;
    return (
      <MultiComboBox {...rest} loadItems={props.loadItems} as="ComboBox" />
    );
  }

  const {loadItems: _loadItems, ...rest} = props;
  return <MultiComboBox {...rest} as="ComboBox" />;
};
Root.displayName = 'Root';
const ComboBox = Object.assign(Root, {
  Anchor,
  SelectedItems,
  ToggleButton,
  Surface,
  Search,
  Items,
});

export type {ComboBoxProps};
export {ComboBox};
